/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type TacticalMeetingMetricsView_circle$ref: FragmentReference;
declare export opaque type TacticalMeetingMetricsView_circle$fragmentType: TacticalMeetingMetricsView_circle$ref;
export type TacticalMeetingMetricsView_circle = {|
  +id: string,
  +databaseId: string,
  +organization: {|
    +id: string,
    +databaseId: string,
  |},
  +supportedRole: ?{|
    +databaseId: string
  |},
  +$refType: TacticalMeetingMetricsView_circle$ref,
|};
export type TacticalMeetingMetricsView_circle$data = TacticalMeetingMetricsView_circle;
export type TacticalMeetingMetricsView_circle$key = {
  +$data?: TacticalMeetingMetricsView_circle$data,
  +$fragmentRefs: TacticalMeetingMetricsView_circle$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TacticalMeetingMetricsView_circle",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Role",
      "kind": "LinkedField",
      "name": "supportedRole",
      "plural": false,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Circle",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '87a166fe08a46e1bc75f8c7f26a3ffb2';

module.exports = node;
